import { Home, Briefcase } from "lucide-react"; // Optional: Install with `npm i lucide-react`

export default function TargetCard() {
  return (
    <div className="rounded-xl bg-background border border-surface-2 p-4 w-[388px] text-white">
      <div className="flex items-center justify-between border-b border-gray-700 pb-4 mb-4">
        {/* Property */}
        <div className="flex-1 pr-4 border-r border-gray-700 text-center">
          <div className="text-sm text-gray-400 mb-4 transition-all duration-300 text-primary dark:text-primary">
            Property
          </div>
          <div className="w-12 h-12 bg-secondary flex items-center justify-center rounded-lg mb-4 mx-auto transition-all duration-300 hover:bg-[#2d3748]">
            <Home
              className="text-indigo-500 transition-transform duration-300 hover:scale-110"
              size={24}
            />
          </div>
          <div className="text-xl font-semibold mb-3  text-primary dark:text-primary">
            15,780
          </div>
          <div className="text-xs text-gray-400 mb-3">60% Target</div>
          <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-indigo-500 bg-[repeating-linear-gradient(45deg,_#6366f1,_#6366f1_10px,_#4f46e5_10px,_#4f46e5_20px)] w-[60%] transition-all duration-1000 ease-in-out animate-progress"
              style={{
                animation: "progress 2s ease-in-out",
                backgroundSize: "20px 20px",
              }}
            ></div>
          </div>
        </div>

        {/* Revenue */}
        <div className="flex-1 pl-4 text-center">
          <div className="text-sm text-gray-400 mb-4 transition-all duration-300 text-primary dark:text-primary">
            Revenue
          </div>
          <div className="w-12 h-12 bg-secondary flex items-center justify-center rounded-lg mb-4 mx-auto transition-all duration-300 hover:bg-[#2d3748]">
            <Briefcase
              className="text-green-400 transition-transform duration-300 hover:scale-110"
              size={24}
            />
          </div>
          <div className="text-xl font-semibold mb-3 transition-all duration-300 text-primary dark:text-primary">
            $78.3M
          </div>
          <div className="text-xs text-gray-400 mb-3">80% Target</div>
          <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-green-400 bg-[repeating-linear-gradient(45deg,_#34d399,_#34d399_10px,_#10b981_10px,_#10b981_20px)] w-[80%] transition-all duration-1000 ease-in-out animate-progress"
              style={{
                animation: "progress 2s ease-in-out",
                backgroundSize: "20px 20px",
              }}
            ></div>
          </div>
        </div>
      </div>

      <div className="text-sm text-primary dark:text-primary hover:underline cursor-pointer flex items-center gap-1">
        View More <span className="ml-1">&rarr;</span>
      </div>
    </div>
  );
}
